// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3otW6","TagBlue":"Button_TagBlue__3dhKU","TagLink":"Button_TagLink__2m0OU","TagLinkActive":"Button_TagLinkActive__3gCuH"};